import { MutationPayload } from "vuex";
import { BreakdanceDocument } from "@/types/document";
import { getBlankTree } from "@/lib/tree/tree";

export const NO_DOCUMENT_ID = -1;

export const NO_DOCUMENT: BreakdanceDocument = {
  documentMeta: {
    postType: "no_document",
    typeLabel: "No Document",
    titleLabel: "No Document",
    id: NO_DOCUMENT_ID,
    templateSettingsType: false
  },
  tree: getBlankTree()
};

export function getModuleNameFromMutation(mutation: MutationPayload) {
  const moduleName = mutation.type.split("/").reverse().pop();

  return moduleName ? moduleName : "";
}
